import { logout } from '@redux/actions/User';
import { useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

type LogoutResult =
  | { success: true; error: undefined }
  | { success: false; error: string };

export const useLogout = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const history = useHistory();

  const handleLogout = async (options?: {
    postLogoutForwardPath?: string;
  }): Promise<LogoutResult> => {
    const response = await dispatch<any>(logout({ queryClient }));
    if (response.status === 200) {
      if (options?.postLogoutForwardPath) {
        history.push(options.postLogoutForwardPath);
      }
      return { success: true, error: undefined };
    } else {
      return { success: false, error: response.error };
    }
  };

  return {
    logout: handleLogout,
  };
};
